import GradeLessonPage from '../components/GradeLessonPage';
import { grade6Topics } from './data';

export default function Grade6Page() {
  return (
    <GradeLessonPage
      grade="6"
      gradeLabel="Grade 6"
      gradeColor="indigo"
      topics={grade6Topics}
      prevGrade={{ label: 'Grade 5', path: '/grade/5' }}
      nextGrade={{ label: 'Grade 7', path: '/grade/7' }}
    />
  );
}
